/**
 * Combined MoJ Q&A set (Wave 1 + Wave 2), de-duplicated by slug.
 * Every /moj question surface (hub, /moj/q/$slug, JSONL feed, sitemap)
 * reads from here so a new wave lands everywhere at once.
 */
import { MOJ_QA, type MojQA } from "./questions-500";
import { MOJ_QA_WAVE2 } from "./questions-wave2";
import { MOJ_QA_WAVE3 } from "./questions-wave3";
import { MOJ_QA_WAVE4 } from "./questions-wave4";
import { liftToFloor } from "../_qa/topup-merge";
import { MOJ_TOPUP_AXIS } from "../_qa/topup-axes";

const merged: MojQA[] = [];
const seen = new Set<string>();
for (const qa of [...MOJ_QA, ...MOJ_QA_WAVE2, ...MOJ_QA_WAVE3, ...MOJ_QA_WAVE4]) {
  if (seen.has(qa.slug)) continue;
  seen.add(qa.slug);
  merged.push(qa);
}

liftToFloor<MojQA["cluster"], MojQA>(merged, {
  prefix: "moj-t7",
  asOf: "ข้อมูลทบทวน ณ สิงหาคม 2569 รูปแบบคำแปลที่ผู้รับยอมรับเปลี่ยนได้ ควรยืนยันก่อนส่งงานแปล เว็บไซต์ไม่แสดงค่าบริการ ขอใบเสนอราคาเฉพาะเคสได้ทางโทรศัพท์ LINE หรืออีเมล",
  authorityTh: "ศาลหรือหน่วยงานผู้รับเอกสาร",
  clusterTh: "งานแปลรับรองสำหรับงานกฎหมายและราชการ",
  primary: MOJ_TOPUP_AXIS,
  clusters: { documents: "documents", process: "process", risk: "legal", location: "use-case" },
});

export const MOJ_QA_ALL: MojQA[] = merged;

export const MOJ_QA_ALL_BY_SLUG: Record<string, MojQA> = Object.fromEntries(
  MOJ_QA_ALL.map((q) => [q.slug, q]),
);

/** Total distinct phrasings covered (question + synonym clusters). */
export const MOJ_QA_PHRASING_COUNT = MOJ_QA_ALL.reduce(
  (n, qa) => n + 1 + qa.synonyms.length,
  0,
);
